import { useState } from 'react'
import { ContainerDragAndDropImage } from './styles'
import { Box, Text } from '@chakra-ui/react'
import { ModalSlideImages } from '../ModalSlideImages'

export function InputDragAndDrop({ setImages, images, label }) {
  const [dragging, setDragging] = useState(false)

  const handleDragEnter = (e) => {
    e.preventDefault()
    setDragging(true)
  }

  const handleDragLeave = (e) => {
    e.preventDefault()
    setDragging(false)
  }

  const handleDrop = (e) => {
    e.preventDefault()
    setDragging(true)

    // Obter os arquivos soltos
    const files = Array.from(e.dataTransfer.files)

    setImages(files)
  }

  const handleImages = (e) => {
    const files = Array.from(e.target.files)

    setImages(files)
  }

  return (
    <Box
      maxW="320px"
      w="full"
      minH="253px"
      rounded="md"
      boxShadow="8px 16px 32px #0000001A"
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      fontSize="14px"
      fontWeight="semibold"
      cursor="pointer"
      gap="29px"
      px="10px"
    >
      <Text
        fontSize="20px"
        position="relative"
        fontWeight="semibold"
        _after={{
          content: '""',
          display: 'block',
          width: '30%',
          height: '1px',
          background: '#378BBF',
          position: 'absolute',
          bottom: '0',
          left: '50%',
          transform: 'translateX(-50%)',
        }}
      >
        {label}
      </Text>
      <ContainerDragAndDropImage
        onDragEnter={handleDragEnter}
        onDragLeave={handleDragLeave}
        onDragOver={(e) => e.preventDefault()}
        onDrop={handleDrop}
        dragging={dragging}
        htmlFor={label}
      >
        <input
          id={label}
          name={label}
          type="file"
          multiple
          onChange={handleImages}
          style={{
            display: 'none',
          }}
        />

        {images?.length === 0
          ? 'Arraste e solte as imagens aqui'
          : `Você soltou ${images?.length} imagens`}
      </ContainerDragAndDropImage>
      <ModalSlideImages images={images} />
    </Box>
  )
}
